import { externalFeesInterface } from "@/interface/order.inteface";

export class ExternalFess implements externalFeesInterface {
  id: string = "";
  name: string = "";
  type: string = "";
  intent: string = "";
  rate: number = 0;
  amount: number = 0;
  is_disabled: boolean = false;
  is_locked: boolean = false;
  tax: any = null;
  constructor(data) {
    Object.assign(this, data);
  }
}
